import React, { useContext, useEffect, useState } from "react";
import FullPageLayout from "../../layout/FullPageLayout";
import { PageSettings } from "../../config/page-settings";
import { Link } from "react-router-dom";
import SendOtp from "./SendOtp";
import VerifyOtp from "./VerifyOtp";
import { useHistory } from "react-router-dom";
import { useTranslation } from "react-i18next";

const ApplicationFromOffice = () => {
  const context = useContext(PageSettings);
  const [showSendOtpModal, setShowSendOtpModal] = useState(false);
  const [showVerifyOtpModal, setShowVerifyOtpModal] = useState(false);
  const [data, setData] = useState({});
  const [selectedButton, setSelectedButton] = useState("");
  const history = useHistory();
  const { t } = useTranslation();

  useEffect(() => {
    context.handleSetPageSidebar(false);
    context.handleSetPageHeader(false);
  }, []);

  const handleOtpSent = (result) => {
    setData(result);
    setShowSendOtpModal(false);
    setShowVerifyOtpModal(true);
  };

  const handleVerifyOtp = (result) => {
    if (result.tenantNotFound) {
      if (selectedButton === "Key Return") {
        history.push({
          pathname: "/key-return",
          state: { email: data.sentTo },
        });
        return;
      }
      if (selectedButton === "Notice to Vacate") {
        history.push({
          pathname: "/file-notice-to-vacate-manually",
          state: { email: data.sentTo },
        });
        return;
      }
    } else {
      if (selectedButton === "Key Return") {
        history.push({
          pathname: `/key-return/${result?.zzID_PEPL}${
            result?.zzID_LESE ? "/" + result?.zzID_LESE : ""
          }`,
          state: { email: data.sentTo },
        });
        return;
      }
      if (selectedButton === "Notice to Vacate") {
        if (result?.zzID_LESE) {
          history.push({
            pathname: `/notice-to-vacate${
              result?.zzID_LESE ? "/" + result?.zzID_LESE : ""
            }/${result?.zzID_PEPL}`,
            state: { email: data.sentTo, mainMenu: true },
          });
        } else {
          history.push({
            pathname: `/file-notice-to-vacate-manually/${result?.zzID_PEPL}`,
            state: { email: data.sentTo },
          });
        }
      }
    }
  };

  return (
    <FullPageLayout
      childrenRowStyle={{ minHeight: "90vh" }}
      childrenRowClass="align-items-center"
    >
      <div className="col-5 " style={{ padding: 30 }}>
        <Link
          to="/onboard-tenant?mainMenu=true"
          className="btn btn-lg btn-success w-100"
        >
          {t("tenantApp.keyReturn.Application")}
        </Link>
        <button
          className="btn btn-lg btn-success w-100 mt-5"
          onClick={() => {
            setSelectedButton("Notice to Vacate");
            setShowSendOtpModal(true);
          }}
        >
          {t("tenantApp.keyReturn.NoticeToVacate")}
        </button>
        <button
          className="btn btn-lg btn-success w-100 mt-5"
          onClick={() => {
            setSelectedButton("Key Return");
            setShowSendOtpModal(true);
          }}
        >
          {t("tenantApp.keyReturn.KeyReturn")}
        </button>
      </div>
      <SendOtp
        showSendOtpModal={showSendOtpModal}
        handleOtpSent={handleOtpSent}
        setShowSendOtpModal={setShowSendOtpModal}
      />
      {data.sentOn && (
        <VerifyOtp
          showVerifyOtpModal={showVerifyOtpModal}
          zzID_PEPL={data.zzID_PEPL}
          sentTo={data.sentTo}
          sentOn={data.sentOn}
          setShowVerifyOtpModal={setShowVerifyOtpModal}
          handleVerifyOtp={handleVerifyOtp}
          tenantNotFound={data?.notFound?.tenantNotFound}
          _id={data?.notFound?._id}
          email={data.email}
          phone={data.Phone_Mobile}
          setData={setData}
        />
      )}
    </FullPageLayout>
  );
};

export default ApplicationFromOffice;
